import { toast } from 'react-toastify';
import auth from './api/auth';
import storage from './storage';
import { TOKEN, USER, PREV_PAGE } from './constants/cookies';
import { tradingDays } from './endpoints-data';

export const processActionErrors = (error) => {
  let message = 'Undfined Error';

  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    message = error.response.data.message;
  } else if (error.message) {
    message = error.message;
  }

  return message;
};

export function getCurrentPageAsSearchParam() {
  const page = window.location.href.replace(window.location.origin, '');
  const encoded = encodeURI(page);

  return encoded || '';
}

export function getResumePageFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location?.hash || '';
  const resumePage = decodeURI(urlParams.get('resume') || '');

  return `${resumePage}${hash}`;
}

export const forcedLogout = () => {
  storage.deleteItem(TOKEN);
  storage.deleteItem(USER);
  sessionStorage.clear();

  auth
    .logout()
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      // refresh
      setTimeout(() => {
        window.location.reload();
      }, 200);
    });
};

export const errorHandler = (error, handleStateChange, setErrors) => {
  // If unauthorized or login expired
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message &&
    error.response.data.message === 'Unauthorized'
  ) {
    forcedLogout();
    return;
  }

  let errorsInternal = {};
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors
  ) {
    const { errors: errorsInternal } = error.response.data;

    if (Object.keys(errorsInternal).length < 1) {
      errorsInternal.global = error.response.data.message;
    }

    handleStateChange(setErrors, errorsInternal);
  } else if (error.message) {
    errorsInternal.global = error.message;
  }

  if (errorsInternal && errorsInternal.global) {
    toast.error(errorsInternal.global);
  }

  if (Object.keys(errorsInternal).length) {
    handleStateChange(setErrors, errorsInternal);
  }
};

const setUrlHashBase = (items = {}) => {
  let urlHash = '#';

  Object.keys(items).forEach((key, index) => {
    const val = items[key];
    const hashString = `${key}=${val}`;

    if (index === 0) {
      urlHash = `${urlHash}${hashString}`;
    } else {
      urlHash = `${urlHash}&${hashString}`;
    }
  });

  window.location.href = urlHash;
};

export const setUrlHash = setUrlHashBase;

export const setUrlHashPageNo = (pageNo) => {
  setUrlHashBase({
    page: pageNo,
  });
};

const getFormattedPageHashBase = () => {
  let { hash = '' } = window.location;

  const hashes = {};

  if (!hash) {
    return hashes;
  }

  hash = hash.substring(1);
  const hashFields = hash.split('&');

  hashFields.forEach((field) => {
    const [fieldName = '', value = ''] = field.split('=');

    if (fieldName) {
      hashes[fieldName] = value;
    }
  });

  return hashes;
};

export const getFormattedPageHash = getFormattedPageHashBase;

export const getPageNoFromUrlHash = () => {
  let pageNo = 1;
  const { page = '' } = getFormattedPageHashBase();

  if (parseInt(page, 10) && parseInt(page, 10) > 0) {
    pageNo = parseInt(page, 10);
  }

  return pageNo;
};

export const getSearchFromUrlHash = () => {
  const { search = '' } = getFormattedPageHashBase();

  return search;
};

export const timeoutPromise = (timeInMs) =>
  new Promise((resolve) => setTimeout(resolve, timeInMs));

export const dayFinder = (dayId) => tradingDays.find((d) => d.id === dayId);

const setPrevPageInStorageBase = (state = {}) =>
  sessionStorage.setItem(PREV_PAGE, JSON.stringify(state));

export const setPrevPageInStorage = setPrevPageInStorageBase;

export const getPrevPageFromStorage = () => {
  if (!sessionStorage.getItem(PREV_PAGE)) {
    setPrevPageInStorageBase({});
  }

  return JSON.parse(sessionStorage.getItem(PREV_PAGE));
};

export const getFormattedBrokerNameClient = (broker) => {
  let formattedBroker = '';

  if (broker && broker.name && broker.clientId) {
    if (broker.name === 'paper-trade') {
      formattedBroker = broker.name;
    } else {
      formattedBroker = `${broker.name}:${broker.clientId}`;
    }
  }

  return formattedBroker;
};

export const getHealthDataAlgo = (data) => {
  let dataHealth = [];

  if (data && data.data && data.data.data) {
    dataHealth = data.data.data;

    dataHealth = dataHealth.filter(({ service }) => service === 'algo') || [];
  }

  return dataHealth;
};

export const isTouch =
  'ontouchstart' in window || navigator.msMaxTouchPoints > 0;

export const errorExtractor = (error = {}) => {
  let errors = {};

  if (error && error.response && error.response.data) {
    if (
      error.response.data.errors &&
      Object.keys(error.response.data.errors).length
    ) {
      // multiple errors
      errors = error.response.data.errors;
    } else {
      errors.global = error.response.data.message;
    }
  } else if (error && error.errors && Object.keys(error.errors).length) {
    errors = error.errors;
  } else if (error && error.message) {
    errors.global = error.message;
  }

  return errors;
};
